@if (loading) {
  <payments-loading-section></payments-loading-section>
}

@if (!loading) {
  <div mat-dialog-content class="dialog-content">
    @if (title) {
      <h1>{{ title }}</h1>
    }
    <ng-content select="[content]"></ng-content>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <ng-content select="[actions]"></ng-content>
  </div>
}
